export default "__VITE_ASSET__0ba2fc0a__"